import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import {
  fetchHomepageIfNeeded, fetchUMapTopicPlanIfNeeded, fetchDiscoverGenreDemoIfNeeded, setUMapSelectedTopic, setSelectedSidebarNav, logout
} from '../../actions'
import {
  makeUMapTopicPlanSelector,
  makeGenreDemoSummarySelector
} from '../../selectors'
import { DefaultFilters } from '../../reducers/topics_reducer'

import SidebarComponent from '../../components/sidebar/SidebarComponent'
import UMapExplorerComponent from '../../components/umap/UMapExplorerComponent'
import Profile from '../../classes/profile'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'
import GoogleAnalytics from '../../classes/GoogleAnalytics'
import { DISCOVER_EXPLORER } from '../../constants/commons'

class UMapExplorerContainer extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    profile: Profile.PropTypes,
    homepage: PropTypes.object,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string
    }),
    logout: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    selectedTopic: PropTypes.string,
    genreDemoSummary: PropTypes.object,
    fetchHomepage: PropTypes.func.isRequired,
    fetchuMapTopicPlan: PropTypes.func.isRequired,
    fetchuMapGenreDemo: PropTypes.func.isRequired,
    setUMapSelectedTopic: PropTypes.func.isRequired,
    plan: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      currentPage: PropTypes.number.isRequired,
      endOfResult: PropTypes.bool.isRequired,
      planFilters: PropTypes.object.isRequired,
      details: PropTypes.object
    }).isRequired,
    setShortcutPreference: PropTypes.func,
    shortcutPreference: PropTypes.string,
    selectedNav: PropTypes.string,
    isContentIntelligence: PropTypes.bool,
    isCatalogAnalysis: PropTypes.bool,
    isPerformanceAnalysis: PropTypes.bool,
    isAIInsights: PropTypes.bool,
    selectedSidebarNav: PropTypes.func
  }

  componentDidMount () {
    GoogleAnalytics.trackGA(DISCOVER_EXPLORER, this.props.location, this.props.profile)
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    if (!homepage) {
      if (this.props.profile && this.props.profile.groups.length > 0) {
        const groups = this.props.profile.groups
        const groupName = groups.filter(group => group !== 'Admin')[0]
        this.props.fetchHomepage(groupName)
      }
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.plan !== this.props.plan &&
      !this.props.plan.isFetching &&
      !this.props.plan.endOfResult &&
      this.props.plan.currentPage >= 1) {
        this.loadMore()
    }
  }

  loadMore = () => {
    const args = {
      page: this.props.plan.currentPage + 1,
      num_recommendations: 1000
    }
    this.props.fetchuMapTopicPlan(this.props.selectedTopic, args)
  }

  render () {
    const { profile, location, plan, selectedTopic, genreDemoSummary, selectedNav, isContentIntelligence, isCatalogAnalysis, isPerformanceAnalysis, isAIInsights } = this.props
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    const myLogout = () => this.props.logout()
    return (
      <>
        <SidebarComponent
          isAdmin={this.props.isAdmin}
          profile={profile}
          shortcut={this.props.shortcut}
          logout={myLogout}
          location={location}
          homepage={homepage ? homepage : this.props.homepage}
          shortcutPreference={this.props.shortcutPreference}
          setShortcutPreference={this.props.setShortcutPreference}
          selectedSidebarNav={this.props.selectedSidebarNav}
          selectedNav={selectedNav}
          isContentIntelligence={isContentIntelligence}
          isCatalogAnalysis={isCatalogAnalysis}
          isPerformanceAnalysis={isPerformanceAnalysis}
          isAIInsights={isAIInsights}
        />
        <UMapExplorerComponent
          isAdmin={this.props.isAdmin}
          shortcut={this.props.shortcut}
          homepage={homepage ? homepage : this.props.homepage}
          fetchuMapTopicPlan={this.props.fetchuMapTopicPlan}
          fetchuMapGenreDemo={this.props.fetchuMapGenreDemo}
          setUMapSelectedTopic={this.props.setUMapSelectedTopic}
          plan={plan}
          selectedTopic={selectedTopic}
          genreDemoSummary={genreDemoSummary}
        />
      </>
    )
  }
}

function mapStateToProps () {
  const planSelector = makeUMapTopicPlanSelector()
  const genreDemoSummarySelector = makeGenreDemoSummarySelector()
  return (state, ownProps) => {
    const profile = state.user.profile && new Profile(state.user.profile)
    const isAdmin = state.user.isAdmin
    const shortcut = ownProps.shortcut
    const homepage = state.homepage.list
    const plan = planSelector(state, ownProps)
    const selectedTopic = state.uMap.selectedTopic
    const genreDemoSummary = genreDemoSummarySelector(state, ownProps)
    const selectedNav = state.sidebar.selectedNav
    const isContentIntelligence = state.sidebar.isContentIntelligence
    const isCatalogAnalysis = state.sidebar.isCatalogAnalysis
    const isPerformanceAnalysis = state.sidebar.isPerformanceAnalysis
    const isAIInsights = state.sidebar.isAIInsights

    return {
      isAdmin,
      profile,
      shortcut,
      homepage,
      plan,
      selectedTopic,
      genreDemoSummary,
      selectedNav,
      isContentIntelligence,
      isCatalogAnalysis,
      isPerformanceAnalysis,
      isAIInsights
    }
  }
}

const defaultPlanArgs = {
  page: 1,
  filters: DefaultFilters,
  num_recommendations: 1000
}

function mapDispatchToProps (dispatch) {
  return {
    fetchHomepage: (groupName) => dispatch(fetchHomepageIfNeeded(groupName)),
    fetchuMapTopicPlan: (topicId, args = defaultPlanArgs) => dispatch(fetchUMapTopicPlanIfNeeded(topicId, args)),
    fetchuMapGenreDemo: (topicIds) => dispatch(fetchDiscoverGenreDemoIfNeeded(topicIds)),
    setUMapSelectedTopic: (topicId) => dispatch(setUMapSelectedTopic(topicId)),
    selectedSidebarNav: (nav) => dispatch(setSelectedSidebarNav(nav)),
    logout: () => dispatch(logout())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UMapExplorerContainer)
